import PropTypes from 'prop-types'
import React, { createElement } from 'react'
import styles from './_button.css'
import Svg from 'components/util/Svg'
import classnames from 'classnames'

const propTypes = {
  el: PropTypes.string,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  children: PropTypes.node,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  size: PropTypes.oneOf([
    'small',
    'medium',
    'large',
    'xlarge',
  ]),
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'default',
    'accent',
    'success',
    'overlay',
    'warning',
    'danger',
    'action',
    'facebook',
    'mmr',
  ]),
}

const defaultProps = {
  type: 'primary',
  size: 'medium',
  el: 'div',
  tabIndex: '0',
}

export function Button (props) {
  const { onClick, size, style, type, icon, children, tabIndex, loading, disabled, className, el } = props
  const combinedClassName = classnames(styles[type], styles[size], className, {
    [styles.disabled]: disabled,
  })

  const inner = (
    <span key='1' className={styles.inner}>
      {icon ? <Svg name={icon} className={styles.icon} /> : null}
      {children}
      {loading ?
        <span className={styles.loading}>{'…'}</span>
      : null}
    </span>
  )

  return createElement(el, {
    onClick,
    tabIndex,
    className: combinedClassName,
    style: style,
  }, [inner])
}

Button.propTypes = propTypes
Button.defaultProps = defaultProps

export default Button



// WEBPACK FOOTER //
// ./src/components/util/Button.jsx